<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/home">Home</router-link> |
      <router-link to="/">Login</router-link> | 
      <router-link to="/about">About</router-link>
    </div> -->
    <v-app>      
      <router-view/>
    </v-app>
  </div>
</template>

<script>


export default {
  
  mounted() {
    //this.$router.push({name: 'Login'})
  },
}
</script>


<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
